import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';
import CustomerCopy from '../CustomerCopy/CustomerCopy';
import CustomerFeedbackForm from '../CustomerFeedbackForm/CustomerFeedbackForm';
import Header from '../Header/Header';
import LuggageList from '../LuggageList/LuggageList';
import TellySheet from '../TellySheet/TellySheet';
import { brandingForPdf } from '../../utils/tenantBrandingCache';
import { resolvePdfBrandColors } from '../../utils/pdfBrandColors';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
});

const CreateHouseHoldPDF = React.memo(({ invoice, branding: brandingOverride }) => {
  const pdfBranding = brandingForPdf(brandingOverride);
  const { primary: brandPrimary } = resolvePdfBrandColors(pdfBranding);
  const organizationLabel =
    (pdfBranding.companyName && String(pdfBranding.companyName).trim()) || 'Ace Relocations';
  const {
    consignorF,
    consignorL,
    consigneeF,
    consigneeL,
    oaddress1,
    oaddress2 = '',
    ocity,
    ostate,
    opincode,
    daddress1,
    daddress2 = '',
    dcity,
    dstate,
    dpincode,
    status,
    contact,
    car,
    email,
    insuranceP,
    insuranceA,
    type,
    date,
    gcnno,
    // carGcnno,

    // will be added later
    rupeesInNumber = '',
    rupeesInText = '',
    chequeNo = '',
    billNo = '',
    lrNo = '',
    bolSignaturePng,
    bolSignerName,
    bolSignedAt,
  } = invoice;

  const invoiceDetail = {
    consignor: { firstName: consignorF, lastName: consignorL },
    consignee: { firstName: consigneeF, lastName: consigneeL },
    contact,
    email,
    originAddress: [oaddress1, `${oaddress2}, ${ocity}`, `${ostate} - ${opincode}`],
    destinationAddress: [daddress1, `${daddress2}, ${dcity}`, `${dstate} - ${dpincode}`],
    status,
    car,
    insuranceP,
    insuranceA,
    type,
    date,
    gcnno,
    // carGcnno,
    customer: {
      firstName: consignorF,
      lastName: consignorL,
      adderess: `${oaddress1}, ${oaddress2}, ${ocity} - ${opincode}`,
      contact,
      gcnno,
      birthDate: '',
      Anniversary: '',
      jobno: gcnno,
      destination: dcity,
      email,
    },
    luggageListDetails: {
      ocity,
      dcity,
      gcnno,
      date,
      from: consignorF,
      to: consignorL,
      originAddress: {
        addressLine1: oaddress1,
        addressLine2: oaddress2 || `${oaddress2}, ${ocity}`,
        addressLine3: `${ocity} - ${opincode}`,
      },

      destinationAddress: {
        addressLine1: daddress1,
        addressLine2: daddress2 || `${daddress2}, ${dcity}`,
        addressLine3: `${dcity} - ${dpincode}`,
      },
    },
    tellyData: {
      fullName: `${consignorF} ${consignorL}`,
      location: ocity,
      mode: 'Road',
      gcnno,
      jobno: '??',
      origin: ocity,
      date,
      destination: dcity,
      originAddress: {
        addressLine1: oaddress1,
        addressLine2: oaddress2 || `${oaddress2}, ${ocity}`,
        addressLine3: `${ocity} - ${opincode}`,
      },

      destinationAddress: {
        addressLine1: daddress1,
        addressLine2: daddress2 || `${daddress2}, ${dcity}`,
        addressLine3: `${dcity} - ${dpincode}`,
      },
    },
  };
  return (
    <Document>
      <Page size='A4' style={styles.page} orientation='landscape'>
        <CustomerCopy
          title='CUSTOMER COPY'
          consignor={invoiceDetail ?.consignor}
          consignee={invoiceDetail ?.consignee}
          originAddress={invoiceDetail ?.originAddress}
          destinationAddress={invoiceDetail ?.destinationAddress}
          type={invoiceDetail ?.type}
          gcnno={invoiceDetail ?.gcnno}
          date={invoiceDetail ?.date}
          bolSignaturePng={bolSignaturePng}
          bolSignerName={bolSignerName}
          bolSignedAt={bolSignedAt}
          branding={pdfBranding}
        />
      </Page>
      <Page size='A4' style={styles.page} orientation='landscape'>
        <CustomerCopy
          title='TRUCK COPY'
          consignor={invoiceDetail ?.consignor}
          consignee={invoiceDetail ?.consignee}
          originAddress={invoiceDetail ?.originAddress}
          destinationAddress={invoiceDetail ?.destinationAddress}
          type={invoiceDetail ?.type}
          gcnno={invoiceDetail ?.gcnno}
          date={invoiceDetail ?.date}
          bolSignaturePng={bolSignaturePng}
          bolSignerName={bolSignerName}
          bolSignedAt={bolSignedAt}
          branding={pdfBranding}
        />
      </Page>
      {/* CustomerFeedbackForm */}

      <Page size='A4' style={styles.page}>
        <Header branding={pdfBranding} />
        <CustomerFeedbackForm
          title='DESTINATION'
          customer={invoiceDetail ?.customer}
          branding={pdfBranding}
          accentColor={brandPrimary}
          carrierName={organizationLabel}
        />
      </Page>
      <Page size='A4' style={styles.page}>
        <Header branding={pdfBranding} />
        <CustomerFeedbackForm
          title='ORIGIN'
          customer={invoiceDetail ?.customer}
          branding={pdfBranding}
          accentColor={brandPrimary}
          carrierName={organizationLabel}
        />
      </Page>

      {/* LuggageList */}
      <Page size='A4' style={styles.page}>
        <LuggageList
          luggageListDetails={invoiceDetail ?.luggageListDetails}
          carrierName={organizationLabel}
        />
      </Page>

      <TellySheet tellyData={invoiceDetail ?.tellyData} branding={pdfBranding} />
    </Document>
  );
});

export default CreateHouseHoldPDF;
